import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SectionService } from '../../services/section.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGallerySectionsResolve {
  private sectionService = inject(SectionService);
  private platformId = inject(PLATFORM_ID);

  resolve(route: ActivatedRouteSnapshot) {
    if (isPlatformServer(this.platformId)) return;
    const gallery = route.parent.data.gallery;
    if (gallery) return this.sectionService.getSections(gallery.id);
  }
}
